/**
 * Breadcrumb  Functional Component
 * @Package - seo/brand
 * @Author - Cybage@UPWA-Team
 * @description: Breadcrumb related to brand SEO
 */

/**
 *  Brand SEO's Breadcrumb Component
 */
import React from 'react'
import SeoBreadcrumb from '../SeoBreadcrumb'

export default function Breadcrumb({ dynamicApiData }) {
  const hasBreadcrumbData = Boolean(dynamicApiData && Object.keys(dynamicApiData).length)

  if (!hasBreadcrumbData) return ''

  return (
    <SeoBreadcrumb
      id="BrandBreadcrumb"
      data={dynamicApiData}
    />
  )
}
